import axios from 'axios'

axios.defaults.baseURL = 'https://open.duyiedu.com'
//请求拦截器
axios.interceptors.request.use((config) => {
  // 在发送请求之前做些什么
  // console.log(config)
  config.params = {
    ...config.params, // 解构以免这里的覆盖别的paramas，可以合成所有params
    appkey: '136975643_1581253537321'
  }
  return config
}, (error) => {
  // 对请求错误做些什么
  return Promise.reject(error)
})
// axios.interceptors.response.use(function (response) {//拦截响应并进行处理
//   if (response.status === 200) {
//     console.log(response.data.data);
//     return response
//   } else {
//     //
//   }
//   return response
// })
export default axios
